import { addMinutes, format, isBefore, isEqual } from 'date-fns';

const getValidTime = (date = '', time = '') => {
  if (date && time) {
    let hours = parseInt(time.split(':')[0], 10);
    let minutes = parseInt(time.split(':')[1].split(' ')[0], 10);

    let period = time.split(' ')[1];
    if (period === 'PM' && hours < 12) {
      hours += 12;
    }
    let t = new Date(format(new Date(date), 'yyyy-MM-dd HH:mm'));
    t.setHours(hours);
    t.setMinutes(minutes);
    return t;
  } else {
    return null;
  }
};

export const getTimeInIntervel = (
  date = null,
  timeFrom = null,
  timeTo = null,
  duration = 5
) => {
  let dt = new Date(date);
  if (dt && timeFrom && timeTo) {
    let tf = getValidTime(dt, timeFrom);
    let tt = getValidTime(dt, timeTo);
    let retArr = [tf];
    if (isBefore(tf, tt)) {
      let newTt = tf;
      while (isBefore(newTt, tt)) {
        newTt = addMinutes(newTt, duration);
        if (!isEqual(newTt, tt)) {
          retArr.push(newTt);
        }
      }
      return retArr;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default getValidTime;
